export const getMessagesQuery = (params) => {
    let defaultParams = {
        tenantIds:[], propertyIds:[], unitIds:[],
        startDate: null, endDate: null, tenants:true, team:true, offset:"", delivered: true, messageTypes: []
    };
    let combinedParams = {...defaultParams, ...params};
    const {
        tenantIds, propertyIds, unitIds, startDate,
        endDate, tenants, team, offset, delivered, messageTypes
    } = combinedParams;

    return `query{
        messages(
            tenantIds: ${JSON.stringify(tenantIds)},
            propertyIds: ${JSON.stringify(propertyIds)},
            unitIds: ${JSON.stringify(unitIds)},
            startDate: ${ !startDate? JSON.stringify("") : JSON.stringify(startDate.format("YYYY-MM-DD"))},
            endDate: ${ !endDate? JSON.stringify("") : JSON.stringify(endDate.format("YYYY-MM-DD"))},
            tenants: ${JSON.stringify(tenants)},
            team: ${JSON.stringify(team)},
            delivered: ${JSON.stringify(delivered)},
            messageTypes: ${JSON.stringify(messageTypes)},
            offset:${JSON.stringify(offset || "")},
            limit:50
        ){
          previous
          next
          summary{
          header
          body
          footer
        }
          messages{
            id
            messageType
            delivered
            failReason
            sendAttempts
            team{
              user{
                firstName
                lastName
                phoneNumber
                email
              }
            }
            tenant{
              unit{
                unitName
                id
                property{
                  id
                  name
                }
              }
              moveOutUnit{
                unitName
                id
              }
              user{
                firstName
                lastName
                phoneNumber
                email
              }
            }
            createdTs
            message
        }
    }
    }`
};

export const askSupportMutation = (params) => {
  const { message } = params;
  return `
      mutation{
          askSupport(message: ${JSON.stringify(message)}){
              success
              errors
          }
    }`
}